import ReactDOM from "react-dom/client";
import "./index.css";
import KioskPage from "@/pages/KioskPage";
import OperatorPage from "@/pages/OperatorPage";

// Tiny path-based router: no react-router dependency needed for two pages.
const path = window.location.pathname.replace(/\/+$/, "");
const Page = path === "/operator" ? OperatorPage : KioskPage;

ReactDOM.createRoot(document.getElementById("root")!).render(<Page />);
